import { render, staticRenderFns } from "./EditBlockNavigationTabs.vue?vue&type=template&id=7eecc13b&"
import script from "./EditBlockNavigationTabs.vue?vue&type=script&lang=js&"
export * from "./EditBlockNavigationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports